export const DIALOG_KEYS = {
  SUBSCRIPTION_REMINDER: "subscriptionReminder",
  UPDATE_AVAILABLE_REMINDER: "updateAvailableReminder"
} as const
